import { useQueryClient } from '@tanstack/react-query';
import { useTransition } from 'react';
import { useTranslations } from 'use-intl';
import { Button, type ButtonSize, type ButtonVariant } from '@leanin/ui';

type Props = {
  label?: string;
  size?: ButtonSize;
  variant?: ButtonVariant;
};

/**
 * Recovery CTA for error states. Invalidates the entire React Query cache,
 * so every active query refetches and the page reconciles with the server.
 * In a Vite SPA there is no `router.refresh()`; query invalidation is the
 * equivalent — every `useQuery` whose `enabled` is true will refetch.
 */
export const RetryButton = ({
  label,
  size = 'md',
  variant = 'primary',
}: Props) => {
  const t = useTranslations('Shell');
  const qc = useQueryClient();
  const [pending, start] = useTransition();
  return (
    <Button
      size={size}
      variant={variant}
      loading={pending}
      onClick={() =>
        start(() => {
          void qc.invalidateQueries();
        })
      }
    >
      {label ?? t('retry')}
    </Button>
  );
};
